import React from 'react';
import { 
  TextField, 
  InputAdornment, 
  FormControlLabel, 
  Switch, 
  Stack,
  Box
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';

interface RecurringTaskSearchProps {
  searchText: string;
  onSearchChange: (value: string) => void;
  showInactive: boolean;
  onShowInactiveChange: (checked: boolean) => void;
}

/**
 * RecurringTaskSearch - Search and filter controls for recurring tasks list
 */
export const RecurringTaskSearch: React.FC<RecurringTaskSearchProps> = ({
  searchText,
  onSearchChange,
  showInactive,
  onShowInactiveChange
}) => {
  return (
    <SectionPaper sx={{ mb: 3 }}>
      <Stack spacing={2}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search tasks by title, description, category, or priority..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: '#64748b' }} />
              </InputAdornment>
            ),
          }}
        />
        <Box>
          <FormControlLabel
            control={
              <Switch
                checked={showInactive}
                onChange={(e) => onShowInactiveChange(e.target.checked)}
                color="primary"
              />
            }
            label="Show paused tasks"
          />
        </Box>
      </Stack>
    </SectionPaper>
  );
};

export default RecurringTaskSearch;
